import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle-basket-empty",
  "use": "circle-basket-empty-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"circle-basket-empty\"><path d=\"M28 14h-4.79l-4.38-6.56a.993.993 0 00-.83-.42c-.32 0-.64.14-.83.43L12.79 14H8c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L29 15c0-.55-.45-1-1-1zM18 9.8l2.8 4.2h-5.6L18 9.8zM24.5 24l-12.99.01L9.31 16H26.7l-2.2 8zM18 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol